import { format } from "date-fns";
import { currency } from "../../../lib/format";
import { FieldPair, Section } from "./section";

interface CertificateData {
  propertyType: string | null;
  useOcc: string | null;
  yearBuilt: number | null;
  eyrBuilt: number | null;
  land: string | null;
  subsoil: string | null;
  upgradeRequirements: string | null;
  heritageListing: string | null;
  seismicGrade: string | null;
  pocFrom: string | null;
  pocTo: string | null;
  valuerName: string | null;
  qualifications: string | null;
  feeAmountExGst: number | null;
  accountNumberForXero: string | null;
}

function formatDate(d: string | null): string {
  if (!d) return "—";
  return format(new Date(d), "d MMMM yyyy");
}

export function SectionCertificate({ data }: { data: CertificateData }): React.ReactElement {
  return (
    <Section id="certificate" title="Certificate Details">
      <div className="grid gap-4 md:grid-cols-2">
        <div className="grid grid-cols-2 gap-x-4 gap-y-3">
          <FieldPair label="Type of Property" value={data.propertyType} />
          <FieldPair label="Use / Occupation" value={data.useOcc} />
          <FieldPair label="Year Built" value={data.yearBuilt?.toString()} />
          <FieldPair label="Effective Year Built" value={data.eyrBuilt?.toString()} />
          <FieldPair label="Land / Contour" value={data.land} />
          <FieldPair label="Soil Type / Subsoil" value={data.subsoil} />
          <FieldPair label="Upgrade Requirements" value={data.upgradeRequirements} />
          <FieldPair label="Heritage Listing" value={data.heritageListing} />
          <FieldPair label="Seismic Grade" value={data.seismicGrade} />
        </div>
        <div className="grid grid-cols-2 gap-x-4 gap-y-3">
          <FieldPair label="Period of Certificate From" value={formatDate(data.pocFrom)} />
          <FieldPair label="Period of Certificate To" value={formatDate(data.pocTo)} />
          <FieldPair label="Valuer Name" value={data.valuerName} />
          <FieldPair label="Qualifications" value={data.qualifications} />
          <FieldPair
            label="Fee Amount (ex GST)"
            value={<span className="tabular-nums">{currency(data.feeAmountExGst)}</span>}
          />
          <FieldPair label="Job Number for Xero" value={data.accountNumberForXero} />
        </div>
      </div>
    </Section>
  );
}
